import { useEffect, useState } from "react";

import classNames from "classnames/bind";

import styles from "../../../styles/avaliacoes/Indicators.module.css";
import { ForEach } from "../../components/control-statements/ForEach";
import { Icon } from "../../components/core/Icon";
const st = (className) => styles[className];

export const Indicators = ({ average }) => {
  const cx = classNames.bind(styles);
  const [indicators, setIndicators] = useState([]);

  const keys = ["service", "product", "delivery", "experience", "environment"];

  const result = keys.reduce((acc, key) => {
    const evaluatedCategories = average.filter(
      (item) => item[key] && item[key].evaluate !== null
    );
    const sum = evaluatedCategories.reduce(
      (total, item) => total + item[key].evaluate,
      0
    );
    acc[key] = sum / evaluatedCategories.length;
    return acc;
  }, {});

  const totals = Object.keys(result).reduce((acc, key) => {
    if (!isNaN(result[key])) acc[key] = result[key];
    return acc;
  }, {});

  const arr = Object.values(totals || {});

  const totalAverage =
    arr.reduce((prev, count) => prev + Number(count), 0) /
    arr.filter((c) => c > 0).length;

  useEffect(() => {
    setIndicators([
      {
        type: "generalRating",
        rating: totalAverage || 0,
        name: "Avaliação geral",
      },
      {
        type: null,
        rating: +(totals?.experience || 0),
        name: "Experiência",
      },
      {
        type: null,
        rating: +(totals?.product || 0),
        name: "Produto",
      },
      {
        type: null,
        rating: +(totals?.delivery || 0),
        name: "Entrega",
      },
      {
        type: null,
        rating: +(totals?.service || 0),
        name: "Serviço",
      },
      {
        type: null,
        rating: +(totals?.environment || 0),
        name: "Ambiente",
      },
    ]);
  }, [average]);

  return (
    <div>
      <div className={st("indicators")}>
        <ForEach
          items={indicators}
          render={(indicator) => (
            <div
              className={cx({
                indicator: true,
                generalRating: indicator.type === "generalRating",
                notEvaluated: !indicator.rating,
              })}
            >
              <div className={st("card")}>
                <div className="d-flex align-center">
                  <span className={st("rating")}>
                    {Number(indicator.rating).toFixed(1)}
                  </span>
                  <div className={st("stars")}>
                    <ForEach
                      items={[1, 1, 1, 1, 1]}
                      render={(_, index) => (
                        <div
                          className={cx({
                            star: true,
                            filled: indicator.rating >= index + 1,
                            outlined: indicator.rating < index + 1,
                          })}
                        >
                          <Icon
                            size="1x"
                            name={
                              indicator.rating >= index + 1
                                ? "fa-star"
                                : "fa-star"
                            }
                            solid={indicator.rating >= index + 1}
                            regular={indicator.rating < index + 1}
                          />
                        </div>
                      )}
                    />
                  </div>
                </div>
                <div className="d-flex flex-column align-start">
                  <p>
                    {indicator.name}{" "}
                    {!indicator.rating && "(Ainda não avaliado)"}
                  </p>
                </div>
              </div>
            </div>
          )}
        />
      </div>
    </div>
  );
};
